import React from "react";
import { useTranslation } from "react-i18next";

import DatasourcesGif from '../../../../assets/agileDashboards/gifs/gif3.gif'

import './seeAction.scss'



function SeeAction() {
    const { t } = useTranslation()

    return (
        <div className="container-seeaction">
            <div className="img-seeaction">
                <img src={DatasourcesGif} alt="" />
            </div>
            <div className="texts-seeaction">
                <h1>{t("rapid_dashboard.action.title")}</h1>
                <p>{t("rapid_dashboard.action.section_text_1")}</p>
                <p>{t("rapid_dashboard.action.section_text_2")}</p>
                
            </div>
        </div>
    )
}


export default SeeAction